import { SIGNUP_SUCCEEDED } from 'constants/Global';

/**
 * Available Realytics tags
 */
const tags = {
    DDEI: 'demande_evaluation_indirect',
    ESTIMA: 'estimation',
    FIRST_ESTIMA: 'premiere_estimation',
};

/**
 * Emit a tag to Realytics API
 *
 * @param {String} tag
 */
function track(tag) {
    if (global.RY) {
        global.RY.track(tag);
    }
}

/**
 * Realytics tracking Service.
 */
export default class RealyticsService {
    /**
     * Track submission of estima form
     *
     * @param {Object} values Submitted form values
     */
    static trackFormSubmit(values) {
        if (values.profile_optin_realtors) {
            RealyticsService.trackDDEi();
        }

        if (values[SIGNUP_SUCCEEDED]) {
            RealyticsService.trackFirstEstima();
        } else {
            RealyticsService.trackEstima();
        }
    }

    /**
     * Track profile optin realtor choice
     */
    static trackDDEi() {
        track(tags.DDEI);
    }

    /**
     * Track noninitial user Estima
     */
    static trackEstima() {
        track(tags.ESTIMA);
    }

    /**
     * Track initial user Estima
     */
    static trackFirstEstima() {
        track(tags.FIRST_ESTIMA);
    }
}
